<template>
  <div class="row">
      <div class="col-md-6">
          <div class="btn btn-block is-btn-link shop-button back-to-shopping-button"  @click.prevent="$emit('back')">
           <i class="far fa-arrow-left"></i> {{ __t('shop.checkout.continue_shopping') }}
          </div>
      </div>
        <div class="col-md-6">
          <button class="btn btn-block is-btn-primary shop-button shop-shipping-button" @click.prevent="$emit('submit')">
            {{ __t('shop.checkout.continue_to_shipping') }} <i class="far fa-arrow-right"></i>
          </button>
        </div>
       
  </div>
</template>

<script>
export default {
  data() {
    return{

    }
  },
}
</script>

<style scoped>

</style>